import { makeStyles } from '@material-ui/core';

import { fieldArrowColor, filledFieldFocused, inputErrorBorder, rightFilledFieldRoot } from '@/styles/inputStyles.ts';

export const useStyles = makeStyles((theme) => ({
    inputLabel: {
        '&.focused': {
            color: theme.palette.common.darkGrey,
        },
        '&.shrink': {
            fontSize: '1rem',
        },
    },
    formControl: {
        width: '100%',
        paddingTop: 14,
        paddingBottom: 14,
        height: '3.75rem',

        justifyContent: 'space-between',

        [theme.breakpoints.down('xs')]: {
            height: '3.75rem',
        },
        borderTopLeftRadius: theme.radius.default,
        borderBottomLeftRadius: theme.radius.default,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        '&:hover': {
            backgroundColor: theme.palette.common.cream_disable,
        },
    },

    downArrow: {
        color: fieldArrowColor(theme),
    },

    form: {
        marginTop: 23,
    },
    textFields: {
        height: '3.75rem',
    },
    textFieldsError: {
        height: '3.75rem',
        ...inputErrorBorder,
    },

    fieldFocused: filledFieldFocused(theme),
    filledInputRoot: {
        ...rightFilledFieldRoot(theme),
        height: '3.75rem',
        borderLeft: 'none',
    },
    coloredRoot: {
        borderBottomRightRadius: 0,
        height: '3.45em',
        borderBottom: `3px solid ${theme.palette.common.yellow}`,
        borderLeft: `3px solid ${theme.palette.common.yellow}`,
    },
    imges: {
        paddingLeft: 12,
    },
    ButtonTextClassMain: {
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.weight.body,
        fontSize: '1rem',
        color: theme.palette.common.darkGrey,
        textTransform: 'none',
        textAlign: 'center',
    },
    redBorder: {
        border: `1px solid ${theme.palette.common.red}`,
        borderRadius: '8px',
    },
    errorText: {
        fontSize: '0.875rem',
        textTransform: 'none',
        lineHeight: '1.5rem',
        color: theme.palette.common.red,
    },
}));
